import { DisplayMarket, MarketsSort, Percent, PERCENT_ZERO, SortBy } from '@silo/types';
import { MarketsTable as BaseMarketsTable } from '@silo/ui';
import { useSiloWeb3 } from '@silo/web3';
import NextLink from 'next/link';
import { TokenLogo } from './token-logo';
import { forwardRef } from 'react';
import { getIsRevenueMarket } from '@silo/utils';

interface MarketsTableProps {
  markets: DisplayMarket[];
  hasMorePages: boolean;
  marketsSort: MarketsSort;
  sortBy: SortBy;
  revenueApr: Percent;
}

const { useMarketLogoSize, tokenLogoSize } = BaseMarketsTable;

export function MarketsTable({
  markets,
  hasMorePages,
  marketsSort,
  sortBy,
  revenueApr,
}: MarketsTableProps): JSX.Element {
  const { protocolKey } = useSiloWeb3();
  const marketLogoSize = useMarketLogoSize();

  return (
    <>
      <BaseMarketsTable.Root>
        <BaseMarketsTable.Head marketsSort={marketsSort} sortBy={sortBy} protocolKey={protocolKey} />

        <BaseMarketsTable.Body>
          {markets.map((market) => {
            const { protocolKey, marketAddress } = market;
            const effectiveRevenueApr = getIsRevenueMarket(protocolKey, marketAddress) ? revenueApr : PERCENT_ZERO;

            return (
              <NextLink
                className={BaseMarketsTable.row({ className: hasMorePages ? '' : 'last:rounded-b-lg' })}
                key={market.marketAddress}
                href={`/silo/${market.marketAddress}`}
              >
                <BaseMarketsTable.RowContent
                  market={market}
                  marketLogo={<TokenLogo size={marketLogoSize} />}
                  tokenLogo={<TokenLogo size={tokenLogoSize} />}
                  revenueApr={effectiveRevenueApr}
                />
              </NextLink>
            );
          })}
        </BaseMarketsTable.Body>
      </BaseMarketsTable.Root>
    </>
  );
}

interface PulseMarketsTableProps {
  pageSize: number;
}

export const PulseMarketsTable = forwardRef<HTMLDivElement, PulseMarketsTableProps>(({ pageSize }, ref) => {
  return (
    <div ref={ref} className={BaseMarketsTable.body({ className: 'mt-0.5 animate-pulse' })}>
      {[...Array(pageSize)].map(() => (
        <BaseMarketsTable.PulseRow className="last:rounded-b-lg" />
      ))}
    </div>
  );
});
